import { render, staticRenderFns } from "./HistoryPublished.vue?vue&type=template&id=fecc623e&"
import script from "./HistoryPublished.vue?vue&type=script&lang=js&"
export * from "./HistoryPublished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports